module.exports = __webpack_public_path__ + "static/kids-bg-2e68f76f475c87eff5f56fcb764eea68.jpg";